/**
 * Minimal Google reCAPTCHA Service (invisible only)
 * @version 2.1.0
 */

/* eslint-disable-next-line no-unused-vars */
const RecaptchaService = (() => {
    let widgetId = null;
    let scriptLoadPromise = null;
    let initPromise = null;

    const isRecaptchaEnabledOnPageLoad = () => {
        const page = document.querySelector('.page');
        const enabled = page?.getAttribute('data-invisible-recaptcha-enabled-on-page-load') === 'true';
        return enabled;
    };

    const _loadScript = () => {
        if (scriptLoadPromise) {
            return scriptLoadPromise;
        }

        scriptLoadPromise = new Promise((resolve) => {
            if (window.grecaptcha && window.grecaptcha.render) {
                resolve();
                return;
            }

            window.__onRecaptchaScriptLoad = () => {
                resolve();
            };

            const script = document.createElement('script');
            script.id = 'recaptcha-script';
            script.src = 'https://www.google.com/recaptcha/api.js?onload=__onRecaptchaScriptLoad&render=explicit';
            document.head.appendChild(script);
        });

        return scriptLoadPromise;
    };

    const CONTAINER_ID = 'bat-recaptcha-service-widget';

    const _renderWidget = (siteKey) => {
        if (widgetId !== null) {
            return widgetId;
        }

        let container = document.getElementById(CONTAINER_ID);
        if (!container) {
            container = document.createElement('div');
            container.id = CONTAINER_ID;
            document.body.appendChild(container);
        }

        if (container.dataset.recaptchaRendered === 'true') {
            return widgetId;
        }

        const renderedElsewhere = document.querySelectorAll('.grecaptcha-badge').length > 0;

        try {
            widgetId = grecaptcha.render(container, {
                sitekey: siteKey,
                size: 'invisible',
                callback: (token) => {
                    window.__captchaResolve?.(token || '');
                }
            });
            container.dataset.recaptchaRendered = 'true';

            if (renderedElsewhere) {
                container.style.display = 'none';
            }
        } catch (e) {
            console.warn('[reCAPTCHA Service] Widget already rendered on this element, skipping re-render:', e);
        }

        return widgetId;
    };

    const _init = () => {
        if (initPromise) {
            return initPromise;
        }

        initPromise = (async () => {
            const siteKey = document.querySelector('.page')?.getAttribute('data-invisible-captcha-key');
            if (!siteKey) {
                return;
            }

            await _loadScript();
            _renderWidget(siteKey);
        })();

        return initPromise;
    };

    const getInvisibleCaptchaToken = async (action = 'submit') => {

        await _init();

        if (widgetId === null || !window.grecaptcha) {
            return '';
        }

        return new Promise((resolve) => {
            window.__captchaResolve = resolve;
            grecaptcha.reset(widgetId);
            grecaptcha.execute(widgetId, { action });
        });
    };

    const _autoInit = () => {
        if (!isRecaptchaEnabledOnPageLoad()) {
            return;
        }

        _init();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => { _autoInit(); });
    } else {
        _autoInit();
    }

    return {
        getInvisibleCaptchaToken
    };
})();
